import * as React from "react";
import { useCallback } from "react";
import { SecurityAppSecurityEventsHistogram } from "@graylog/enterprise-api";
import EventsHistogram from "components/events/EventsHistogram";
import useUserDateTime from "hooks/useUserDateTime";
import { defaultTimeRange } from "components/events/fetchEvents";
import { parseSearchParams } from "security-app/hooks/api/securityEventsAPI";
import parseSecurityEventFilters from "security-app/components/SecurityEvents/Alerts/parseSecurityEventFilters";
const fetchSecurityEventsHistogram = async (searchParams, timezone) => {
  const parsedFilters = parseSecurityEventFilters(searchParams.filters, defaultTimeRange);
  const { timerange } = parsedFilters;
  return SecurityAppSecurityEventsHistogram.histogram(parseSearchParams(searchParams, timezone)).then((results) => ({
    timerange,
    results
  }));
};
const SecurityEventsHistogram = ({ searchParams, setFilters }) => {
  const { userTimezone } = useUserDateTime();
  const _fetchSecurityEventsHistogram = useCallback(
    (_searchParams) => fetchSecurityEventsHistogram(_searchParams, userTimezone),
    [userTimezone]
  );
  return /* @__PURE__ */ React.createElement(
    EventsHistogram,
    {
      searchParams,
      setFilters,
      eventsHistogramFetcher: _fetchSecurityEventsHistogram
    }
  );
};
export default SecurityEventsHistogram;
